<template>
  <div class="unauthorized-access">
    <div class="unauthorized-container">
      <div class="unauthorized-header">
        <div class="logo-section">
          <h1>Dakota Steel and Trim</h1>
          <h2>Trim Designer Portal</h2>
        </div>
      </div>

      <div class="unauthorized-content">
        <div class="lock-icon">
          🔒
        </div>
        
        <h3>Access Not Authorized</h3>
        
        <div class="message-section">
          <p class="primary-message">
            Access to the Trim Designer Portal is restricted to authorized customers only.
          </p>
          
          <p class="secondary-message">
            Please access the Trim Designer through the official Dakota Steel and Trim customer portal:
          </p>
          
          <div class="portal-link">
            <a href="https://portal.dakotasteelandtrim.com" target="_blank" rel="noopener noreferrer">
              portal.dakotasteelandtrim.com
            </a>
          </div>
        </div>

        <div class="contact-section">
          <h4>Need Help?</h4>
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-label">Phone:</span>
              <span class="contact-value">(866) 987-9080</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">Email:</span>
              <span class="contact-value">trimdesigner@dakotasteelandtrim.com</span>
            </div>
          </div>
        </div>

        <div class="footer-note">
          <p>If you believe you should have access to this portal, please contact our customer support team.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnauthorizedAccess',
  mounted() {
    // Set page title
    document.title = 'Access Not Authorized - Dakota Steel and Trim';
  }
}
</script>

<style scoped>
.unauthorized-access {
  min-height: 100vh;
  background: #f1f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.unauthorized-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
  overflow: hidden;
}

.unauthorized-header {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 30px;
  text-align: center;
}

.unauthorized-header h1 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.unauthorized-header h2 {
  margin: 8px 0 0 0;
  font-size: 1.1rem;
  font-weight: 400;
  opacity: 0.9;
}

.unauthorized-content {
  padding: 40px 30px;
  text-align: center;
}

.lock-icon {
  font-size: 3rem;
  margin-bottom: 20px;
  opacity: 0.7;
}

.unauthorized-content h3 {
  color: #2c3e50;
  font-size: 1.5rem;
  margin: 0 0 30px 0;
  font-weight: 600;
}

.message-section {
  margin-bottom: 30px;
}

.primary-message {
  font-size: 1.1rem;
  color: #2c3e50;
  margin: 0 0 15px 0;
  font-weight: 500;
}

.secondary-message {
  color: #5a6c7d;
  margin: 0 0 20px 0;
  line-height: 1.5;
}

.portal-link {
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
}

.portal-link a {
  color: #007bff;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: color 0.2s ease;
}

.portal-link a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.contact-section {
  border-top: 1px solid #e9ecef;
  padding-top: 25px;
  margin-bottom: 25px;
}

.contact-section h4 {
  color: #2c3e50;
  font-size: 1.1rem;
  margin: 0 0 15px 0;
  font-weight: 600;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-item {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.contact-label {
  font-weight: 600;
  color: #5a6c7d;
  min-width: 60px;
}

.contact-value {
  color: #2c3e50;
}

.footer-note {
  border-top: 1px solid #f1f3f4;
  padding-top: 20px;
}

.footer-note p {
  font-size: 0.9rem;
  color: #6c757d;
  margin: 0;
  font-style: italic;
}

/* Responsive Design */
@media (max-width: 768px) {
  .unauthorized-access {
    padding: 10px;
  }
  
  .unauthorized-container {
    margin: 0;
  }
  
  .unauthorized-header {
    padding: 25px 20px;
  }
  
  .unauthorized-header h1 {
    font-size: 1.5rem;
  }
  
  .unauthorized-header h2 {
    font-size: 1rem;
  }
  
  .unauthorized-content {
    padding: 30px 20px;
  }
  
  .contact-item {
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }
  
  .contact-label {
    min-width: auto;
  }
}
</style>